import React from 'react';
import { PrematchContext } from '../Prematch';
import { getTorneiInEvidenza } from '../../data/utils/getTorneiInEvidenza';
import { iconSportCssClass } from '../../data/utils/iconSportCssClass';
import MenuCategoryItem from './MenuCategoryItem';
import { labels } from '../../data/labels';

function TopMatchMenu(props) {
    const prematchContext = React.useContext(PrematchContext);
    let highlights = getTorneiInEvidenza(props.data.sport, prematchContext.temporalFilter.type).sportsList;

    return (
        <>
            {highlights.length > 0 &&
                <>
                    <span className="list-heading">{labels['prematch.tournament.top_leagues']}</span>
                    <div className="menu-container">
                        <div className="menu-container">
                            {highlights.map(t => {
                                return (
                                    <React.Fragment key={t.id}>
                                        <div className="list-element sport-collapse">
                                            <div className={`prematch-sport-img big ${iconSportCssClass(t.id, t.iconClass)}`}></div>
                                            <span className="list-element-text list-heading">{t.descrizione}</span>
                                            <div className="d-flex push-right mr-2">
                                                {t.isLive &&
                                                    <div className="badge-live mr-2"></div>
                                                }
                                                <span className="list-element-info"></span>
                                            </div>
                                        </div>
                                        {t.competitions.map(function (r) {
                                            function handleClick() {
                                                prematchContext.openTournament(r.uniqueId);
                                            }
                                            return (
                                                <MenuCategoryItem key={r.id}
                                                                id={r.id}
                                                                desc={r.descrizione}
                                                                info={r.eventsCount}
                                                                sportRef={r.sportRef}
                                                                categoryRef={r.categoryRef}
                                                                iconClass={r.iconClass}
                                                                isLive={r.isLive}
                                                                action={handleClick}
                                                                urlPath={r.urlPath}
                                                                urlPathSuffix={r.urlPathSuffix}
                                                                urlPathSeo={r.urlPathSeo}
                                                                urlPathSeoSettings = {r.urlPathSeoSettings} />
                                            );
                                        })}
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    </div>
                </>
            }
        </>
    );
}

export default TopMatchMenu;